module.exports = " <div angular-stats watch-count=.watch-count digest-length=.digest-length on-watch-count-update=onWatchCountUpdate(watchCount) on-digest-length-update=onDigestLengthUpdate(digestLength)> <div class=info> <div class=watchers> Watches: <span class=watch-count></span> </div> <div class=digest-cycle> Digest: <span class=digest-length></span>ms </div> <md-list class=links> <md-list-item ng-repeat=\"link in ::$ctrl.links\"> <a ng-href={{::link.path}} target=_blank>{{::link.title}}</a> </md-list-item> </md-list> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/developer-bar/developer-bar.html
 ** module id = 56
 ** module chunks = 0
 **/